import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

export const Pagination = ({ page, pages, onPage }) => {
  const { t } = useLang();
  if (pages <= 1) return null;
  const btn = "inline-flex items-center gap-1 px-4 py-2 rounded-full border border-white/10 text-sm text-white/75 hover:border-gold/40 disabled:opacity-30 transition-colors duration-200";
  return (
    <div className="flex items-center justify-center gap-3 mt-10" data-testid="directory-pagination">
      <button className={btn} disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="directory-prev-page">
        <ChevronLeft size={14} className="rtl:rotate-180" /> {t("directory.prev")}
      </button>
      <span className="text-sm text-white/50" data-testid="directory-page-indicator">{page} / {pages}</span>
      <button className={btn} disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid="directory-next-page">
        {t("directory.next")} <ChevronRight size={14} className="rtl:rotate-180" />
      </button>
    </div>
  );
};
